import React from "react";
import { useTranslation } from "react-i18next";
import PageLoader from "../../components/common/PageLoader";
import LandingHeader, { LandingSeo } from "../../components/landing/LandingHeader";
import { getMainSiteUrl, IS_LANDING, LANDING_PAGE_SLUG } from "../../constants/appConfig";
import { useWordPressPage } from "../../hooks/useWordPressPage";
import { getFeaturedImageUrl } from "../../services/wpPagesApi";
import "./LandingPage.css";

function LandingPage() {
  const { t } = useTranslation();
  const { page, loading, error } = useWordPressPage(LANDING_PAGE_SLUG);
  const heroImage = getFeaturedImageUrl(page);
  const showLandingHeader = IS_LANDING;

  if (loading) {
    return (
      <>
        {showLandingHeader ? <LandingHeader /> : null}
        <PageLoader />
      </>
    );
  }

  if (error || !page) {
    return (
      <>
        {showLandingHeader ? <LandingHeader /> : null}
        <section className="landing-page__state">
          <h1>{t("Content unavailable")}</h1>
          <p>{t("landing.loadError", { slug: LANDING_PAGE_SLUG })}</p>
          <a href={getMainSiteUrl()} className="landing-page__cta">
            {t("Visit Main Site")}
          </a>
        </section>
      </>
    );
  }

  return (
    <>
      <LandingSeo page={page} />
      {showLandingHeader ? <LandingHeader /> : null}
      {heroImage ? (
        <section
          className="landing-page__hero"
          style={{ backgroundImage: `url(${heroImage})` }}
          aria-hidden="true"
        />
      ) : null}
      <article className="landing-page">
        <header className="landing-page__intro">
          <h1
            className="landing-page__title"
            dangerouslySetInnerHTML={{ __html: page.title.rendered }}
          />
        </header>
        <div
          className="landing-page__content"
          dangerouslySetInnerHTML={{ __html: page.content.rendered }}
        />
        <footer className="landing-page__footer">
          <a href={getMainSiteUrl()} className="landing-page__cta">
            {t("Explore CAF Sports")}
          </a>
        </footer>
      </article>
    </>
  );
}

export default LandingPage;
